import React from "react";
import { View, Text, StyleSheet } from "react-native";
import Feather from "react-native-vector-icons/Feather";
import { ODSIcon } from "../../atoms/ODSIcon";
const EmptyState = () => {
  return (
    <View style={styles.container}>

      <ODSIcon color={"#777"} icon={"TB-User-Circle"} size={40} />

      <Text style={styles.title}>No Joint Tenants Added</Text>
      <Text style={styles.desc}>
        Add a joint tenant to share this tenancy with someone.
      </Text>
    </View>
  );
};

export default EmptyState;

const styles = StyleSheet.create({
  container: {
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 40,
  },
  title: {
    fontSize: 18,
    fontWeight: "700",
    marginTop: 10,
    color: "#333",
  },
  desc: {
    fontSize: 14,
    color: "#777",
    marginTop: 6,
    textAlign: "center",
    paddingHorizontal: 20,
  },
});